// document.addEventListener("DOMContentLoaded", function () {
//   let videoContainer = document.querySelector(".video-container");
//   if (document.querySelector(".video-container")) {
//     let hoverPlay = document.querySelector(".content button.play");
//     let videoType = videoContainer.dataset.videoType;
//     let videoEl, imgEl, divider;
//     if (videoType == "video") {
//       videoEl = document.querySelector(".video-container video");
//       imgEl = document.querySelector(".video-container img");
//       divider = document.querySelector(".content .divider");
//       videoEl.addEventListener("play", hideHoverPlay, false);
//       videoEl.addEventListener("playing", hideHoverPlay, false);
//       // videoEl.addEventListener("pause", showHoverPlay, false);
//       // videoEl.addEventListener("seeking", showHoverPlay, false);
//       videoEl.addEventListener("ended", showHoverPlay, false);
//       hoverPlay.addEventListener("click", playVideo, false);
//     }

//     function hideHoverPlay() {
//       hoverPlay.style.pointerEvents = "none";
//       hoverPlay.style.opacity = "0";
//       videoEl.style.opacity = ".51";
//       imgEl.style.opacity = "0";
//     }
//     function showHoverPlay() {
//       hoverPlay.style.pointerEvents = "auto";
//       hoverPlay.style.opacity = "1";
//     }

//     function playVideo() {
//       try {
//         videoEl.load();
//         videoEl.play();
//         console.log(videoEl);
//       } catch (err) {
//         console.log(err);
//       }
//     }
//   }
// });
document.addEventListener("DOMContentLoaded", function () {
  //modal-content
  let videoContainer = document.querySelector(".banner-video .modal-content");
  if (document.querySelector(".banner-video .modal-content")) {
    let hoverPlay = document.querySelector(".content button.play");
    let videoType = videoContainer.dataset.videoType;
    let videoEl, imgEl, divider;
    if (videoType == "video") {
      videoEl = document.querySelector(".banner-video .modal-content video");
      imgEl = document.querySelector(".banner-video .modal-content img");
      divider = document.querySelector(".content .divider");
      videoEl.addEventListener("play", hideHoverPlay, false);
      videoEl.addEventListener("playing", hideHoverPlay, false);
      // videoEl.addEventListener("pause", showHoverPlay, false);
      // videoEl.addEventListener("seeking", showHoverPlay, false);
      videoEl.addEventListener("ended", showHoverPlay, false);
      hoverPlay.addEventListener("click", playVideo, false);
    }

    function hideHoverPlay() {}
    function showHoverPlay() {}

    function playVideo() {
      try {
        videoEl.load();
        videoEl.play();
        // console.log(videoEl);
      } catch (err) {
        // console.log(err);
      }
    }
  }
});
